import { h } from 'preact'
import PropTypes from 'prop-types'

import classNames from 'lib/classNames'
import Icon from 'components/Icon'

export default function CallControls({
  isMicMuted,
  isVideoEnabled,
  isScreenSharing,
  isChatOpen,
  callQuality,
  onToggleMute,
  onToggleVideo,
  onToggleScreenShare,
  onToggleChat,
  onEndCall,
  chatMessageCount,
}) {
  const micClass = classNames('CallControls-btn', {
    active: !isMicMuted,
    off: isMicMuted,
  })

  const videoClass = classNames('CallControls-btn', {
    active: isVideoEnabled,
    off: !isVideoEnabled,
  })

  const screenClass = classNames('CallControls-btn', {
    active: isScreenSharing,
  })

  const chatClass = classNames('CallControls-btn', {
    active: isChatOpen,
  })

  return <div className="CallControls">
    <div className="CallControls-group">
      <button
        className={micClass}
        onClick={onToggleMute}
        title={isMicMuted ? 'Unmute microphone' : 'Mute microphone'}
      >
        <Icon type={isMicMuted ? 'audioOff' : 'audio'} />
      </button>

      <button
        className={videoClass}
        onClick={onToggleVideo}
        title={isVideoEnabled ? 'Turn off camera' : 'Turn on camera'}
      >
        <Icon type={isVideoEnabled ? 'video' : 'disabledVideo'} />
      </button>

      <button
        className={screenClass}
        onClick={onToggleScreenShare}
        title={isScreenSharing ? 'Stop sharing' : 'Share screen'}
      >
        <Icon type="shareScreen" />
      </button>

      <button
        className={chatClass}
        onClick={onToggleChat}
        title={isChatOpen ? 'Close chat' : 'Open chat'}
      >
        <Icon type="chatIcon" />
        {chatMessageCount > 0 && !isChatOpen &&
          <span className="CallControls-badge">{chatMessageCount}</span>
        }
      </button>
    </div>

    {callQuality &&
      <div className="CallControls-group">
        <span className={classNames('CallControls-quality', {
          excellent: callQuality === 'excellent',
          good: callQuality === 'good',
          poor: callQuality === 'poor',
        })} title={'Connection: ' + callQuality}>
          <Icon type="connectionStatus" />
        </span>
      </div>
    }

    <div className="CallControls-group">
      <button
        className="CallControls-btn CallControls-btn-endCall"
        onClick={onEndCall}
        title="End call"
      >
        <Icon type="close" />
      </button>
    </div>
  </div>
}

CallControls.propTypes = {
  isMicMuted: PropTypes.bool,
  isVideoEnabled: PropTypes.bool,
  isScreenSharing: PropTypes.bool,
  isChatOpen: PropTypes.bool,
  callQuality: PropTypes.string,
  onToggleMute: PropTypes.func.isRequired,
  onToggleVideo: PropTypes.func.isRequired,
  onToggleScreenShare: PropTypes.func.isRequired,
  onToggleChat: PropTypes.func.isRequired,
  onEndCall: PropTypes.func.isRequired,
  chatMessageCount: PropTypes.number,
}
